import { environment } from './../../../environments/environment';
import { AcumaticaService } from './../acumatica.service';
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Acumatica } from "../acumatica-field-decorator";
import { AcumaticaRequestOptions } from "../acumatica.service";
import { AcumaticaEntity, AcumaticaEntityService } from "./acumatica-entity";

@Injectable({
    providedIn: 'root'
})
export class StockItemSearchService extends AcumaticaEntityService {
    constructor(
        protected acumatica: AcumaticaService
    ) {
        super(acumatica, 'StockItemSearch', StockItemSearch);
    }

    search(searchText: string): Observable<StockItemSearch>;
    search(search: StockItemSearch): Observable<StockItemSearch>;
    search(searchText: string, options: AcumaticaRequestOptions): Observable<StockItemSearch>;
    search(search: StockItemSearch, options: AcumaticaRequestOptions): Observable<StockItemSearch>;
    search(inquiry: string | StockItemSearch, options: AcumaticaRequestOptions = {}): Observable<StockItemSearch> {
        return new Observable<StockItemSearch>(subscriber => {
            options = {
                ...{
                    expand: 'Results',
                    loader: 'Searching Items...'
                },
                ...options
            };

            if (typeof inquiry == 'string') {
                inquiry = new StockItemSearch({ Search: inquiry });
            }

            this.putEntity(inquiry, options).subscribe(subscriber)
        });
    }
}

export class StockItemSearchResult extends AcumaticaEntity {
    @Acumatica() InventoryID!: string;
    @Acumatica() Description!: string;

    @Acumatica() ClassID!: string;
    @Acumatica() ClassDescription!: string;

    @Acumatica() PricelistType!: string;
    @Acumatica('ItemStatus') Status!: string;
    @Acumatica({
        reader: (value: string) =>
            environment.mode == 'rep' && value == 'Orange' ? 'Green' : value
    }) LifeCycle!: string;
}

export class StockItemSearch extends AcumaticaEntity {
    @Acumatica('Search') search?: string;
    @Acumatica() RepAppAvailable: boolean = true;
    @Acumatica() DefaultWarehouse?: string;
    @Acumatica(StockItemSearchResult) Results: StockItemSearchResult[] = [];
}